export default __webpack_public_path__ + "static/media/Read-Light_V3000.8d200070.woff";